import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const WheelchairAccessIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 15.0757 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 11.3036C5.87737e-05 9.26707 0.910175 7.44245 2.34339 6.21543C2.63017 5.96994 3.06178 6.00341 3.30726 6.29019C3.5526 6.57694 3.51916 7.00771 3.2325 7.25318C2.08954 8.23156 1.36711 9.68302 1.36705 11.3036C1.36705 14.2467 3.7533 16.633 6.69641 16.633C8.2399 16.6328 9.6295 15.9774 10.6035 14.9277C10.8603 14.651 11.2925 14.6346 11.5692 14.8912C11.8458 15.1479 11.8622 15.5801 11.6057 15.8569C10.3838 17.1738 8.63593 17.9999 6.69641 18C2.9983 18 0 15.0017 0 11.3036Z"
      fill="currentColor"
    />
    <path
      d="M4.98589 3.66156C5.3544 3.58048 5.71895 3.8137 5.80024 4.18221L6.47398 7.23938L9.55251 6.54785C9.92071 6.46522 10.2867 6.69679 10.3695 7.06494C10.4522 7.43313 10.2205 7.79906 9.85244 7.88197L6.76857 8.57439L7.45921 11.7045L12.3979 10.722L12.5242 10.7086C12.8157 10.7054 13.0837 10.8897 13.1793 11.175L15.0403 16.7384C15.16 17.0964 14.9666 17.4838 14.6086 17.6035C14.2507 17.7232 13.8633 17.5298 13.7435 17.1718L12.0739 12.1798L7.07028 13.1766C6.70545 13.2492 6.34944 13.0165 6.26928 12.6533L4.46523 4.47591C4.38416 4.1074 4.61737 3.74285 4.98589 3.66156Z"
      fill="currentColor"
    />
    <path
      d="M6.21504 1.56325C6.21504 2.4266 5.51515 3.12649 4.65179 3.12649C3.78843 3.12649 3.08854 2.4266 3.08854 1.56325C3.08854 0.699889 3.78843 0 4.65179 0C5.51515 0 6.21504 0.699889 6.21504 1.56325Z"
      fill="currentColor"
    />
  </svg>
)

export default WheelchairAccessIcon
